import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Invite } from '@/types/user';
import { utils } from '../../utils';

type RequestParams = {
  inviteCode: string;
};

export const getInviteByCode = async ({ inviteCode }: RequestParams): Promise<EndpointResponse<Invite>> => {
  try {
    const response = await scopedApi(GLOBAL_SCOPE).get<EndpointResponse<Invite>>('/organization/invite/by_code', {
      params: { invite_code: inviteCode },
      authPolicy: 'anonymous',
    });
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
